var stickyShareBar = function(){
  var bar;
  var body;

  var _init = function(){
    bar = document.getElementById('m-share-bar');
    body = document.body;

    window.addEventListener('scroll', _setSticky);
  }

  var _setSticky = function(){
    if (window.pageYOffset >= 44 && !body.classList.contains('is-share-bar-sticky')) {
      body.classList.add('is-share-bar-sticky');
    }

    if (window.pageYOffset < 44 && body.classList.contains('is-share-bar-sticky')) {
      body.classList.remove('is-share-bar-sticky'); 
    }
  }

  return{
    init: _init
  }

}();

if (document.getElementById('m-share-bar')) {
  stickyShareBar.init();
}